import { render, staticRenderFns } from "./UsersActive.vue?vue&type=template&id=54856d12&"
import script from "./UsersActive.vue?vue&type=script&lang=js&"
export * from "./UsersActive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports